/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:13:06
 * @Explain: 数据报表
 */

export default {
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS1':
    '发送请求量、请求通过量、邮件送达量、邮件打开量、退订用户量、注册用户量',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS2':
    '发送请求量、请求通过量、邮件送达量、邮件打开量、退订用户量、活跃用户量',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS3':
    '发送请求量、请求通过量、邮件送达量、邮件打开量、退订用户量、付费用户',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS4':
    '发送请求量、请求通过量、邮件送达量、邮件打开量、退订用户量',
  'DATA.REPORT.RENEW': '拉新',
  'DATA.REPORT.INVIGORATE': '促活',
  'DATA.REPORT.PAY': '付费',
  'DATA.REPORT.ACTIVITY.DESC.LIST': [
    {
      label: '拉新',
      content: ['<p>此类型活动，展示注册用户量等数据统计</p>'],
    },
    {
      label: '促活',
      content: ['<p>此类型活动，展示活跃用户量等数据统计</p>'],
    },
    {
      label: '付费转化',
      content: ['<p>此类型活动，展示付费用户量等数据统计</p>'],
    },
  ],
  'DATA.REPORT.TYPE': '类型',
  'DATA.REPORT.VALUE': '值',
  // 'DATA.REPORT.DATA.BASE.INFO': '活动信息',
  'DATA.REPORT.DATA.OVERVIEW': '数据概况',
  'DATA.REPORT.GENERAL.TITLEINFO.TITLE': '数据概况说明',
  'DATA.REPORT.GENERAL.SUBTITLE.1': '数据变化趋势',
  'DATA.REPORT.GENERAL.SUBTITLE.2': '触达转化统计',
  'DATA.REPORT.FUNNEL.CHART': '漏斗图',
  'DATA.REPORT.GENERAL.DESC.LIST': [
    {
      label: '发送申请量',
      content: [
        '<small>系统投递出去的邮件数量</small>',
        '<p>系统会过滤掉已经取消订阅的玩家邮箱</p>',
      ],
    },
    // {
    //   label: '实际发送量',
    //   content: ['<small>投递出的邮件被下游接收的数量</small>', '<p>下游会进行简单的邮箱格式及黑名单校验过滤</p>'],
    // },
    {
      label: '邮件送达量',
      content: [
        '<small>通过请求中送达到用户邮件服务器的数量</small>',
        '<p>用户邮件服务器会经反垃圾策略判断，拒收部分邮件</p>',
      ],
    },
    {
      label: '邮件打开量',
      content: ['<small>被用户打开的独立邮件数量</small>'],
    },
    {
      label: '应用内用户行为统计',
      content: [
        '<small>注册用户量</small>',
        '<p>注册游戏（首次登录游戏）的时间大于投递给该用户时间的独立用户数量，仅累计7天内，展示当前数据。</p>',
      ],
    },
    {
      label: '',
      content: [
        '<small>活跃用户量</small>',
        '<p>登录游戏时间大于投递给该用户时间的独立用户数量，仅累计7天内，展示当前数据。</p>',
      ],
    },
    {
      label: '',
      content: [
        '<small>付费用户量</small>',
        '<p>游戏内付费时间大于投递给该用户时间的独立用户数量，仅累计7天内，展示当前数据</p>',
      ],
    },
    {
      label: '取消订阅用户数',
      content: [
        '<small>退订邮件的用户数量</small>',
        '<p>当依次发送了多个活动A、……、B，多个活动均包含同个用户，用户取消订阅后，该数据记录在取消订阅前的最后一次触达活动“B”的取消订阅中。该指标随用户取消订阅/重新订阅动态变化</p>',
      ],
    },
  ],

  // 触达转化对比
  'DATA.REPORT.DELIVERY.VOLUME': '邮件送达量',
  'DATA.REPORT.DELIVERY.VOLUME.1': '已点击',
  'DATA.REPORT.DELIVERY.VOLUME.2': '未送达',
  'DATA.REPORT.DELIVERY.VOLUME.3': '未打开',
  'DATA.REPORT.DELIVERY.VOLUME.4': '未点击',
  'DATA.REPORT.RATIO': '触达转化对比',
  'DATA.REPORT.RATIO.TITLEINFO.TITLE': '触达转化对比说明',
  'DATA.REPORT.RATIO.DESC.LIST': [
    {
      label: '送达率',
      content: ['<p>当日送达量/当日请求通过量</p>'],
    },
    {
      label: '打开率',
      content: ['<p>当日递送成功的邮件中被打开的数量/当日送达量</p>'],
    },
    {
      label: '退订率',
      content: [
        '<p>当日递送成功的邮件中，取消订阅的用户数/当日递送成功的邮件数量</p>',
      ],
    },
    {
      label: '注册转化率',
      content: [
        '<p>当日递送成功的邮件中，注册了游戏账号的邮箱数/当日递送成功的邮件数量</p>',
      ],
    },
    {
      label: '活跃转化率',
      content: [
        '<p>当日递送成功的邮件中，登录过游戏的玩家邮箱数/当日递送成功的邮件数量</p>',
      ],
    },
    {
      label: '付费转化率',
      content: [
        '<p>当日递送成功的邮件中，游戏内付费的玩家邮箱数/当日递送成功的邮件数量</p>',
      ],
    },
  ],
  'DATA.REPORT.SELECT.EVENT': '请选择活动',
  'DATA.REPORT.SELECT.ACTIVITY.TYPE': '请选择活动类型',
  'DATA.REPORT.SELECT.ACTIVITY.CYCLE': '请选择活动周期',
  'DATA.REPORT.SELECT.LANGUAGE': '请选择语言',
  'DATA.REPORT.PLEASE.SELECT.PERIOD': '请选择周期',
  'DATA.REPORT.PLEASE.SELECT.DATE': '请选择时间',
  'DATA.REPORT.ALL.LANGUAGE': '所有语言',
  'DATA.REPORT.SELECT.REGION': '请选择区域',
  'DATA.REPORT.ALL.REGION': '所有区域',
  'DATA.REPORT.DETAIL': '数据详情',
  'DATA.REPORT.DATE': '送达日期',
  'DATA.REPORT.DATE.ERRORINFO': '查询时间跨度最长为1个月，请重新选择',

  // 邮件打开分析
  'DATA.REPORT.MAIL.OPEN.ANALYSIS': '邮件打开分析',
  'DATA.REPORT.MAIL.DELIVERY.DAY': '{num}天',
  'DATA.REPORT.DELIVERY.DAY': '送达后第{num}天的打开量',
  'DATA.REPORT.MAIL.DELIVERY.DAY.TIPS': '送达后{num}天的邮件打开量统计',
  'DATA.REPORT.MAIL.OPEN.DATE': '邮件送达量/打开日期',
  'DATA.REPORT.CUMULATIVE.OPEN.QUANTITY': '累计打开量',
  'DATA.REPORT.CUMULATIVE.OPEN.RATE': '累计打开率',

  // 注册数据分析
  'DATA.REPORT.REGIST.DATA.ANALYSIS': '{name}数据分析',
  'DATA.REPORT.REGIST.DATA.GEN.DATE': '邮件送达量/注册数据产生日期',
  'DATA.REPORT.CUMULATIVE.REGIST': '累计注册量',
  'DATA.REPORT.CUMULATIVE.REGIST.RATE': '累计注册率',

  'DATA.REPORT.ANALYSIS.TITLE.1': '7天注册统计',
  'DATA.REPORT.ANALYSIS.TITLE.2': '7天回流统计',
  'DATA.REPORT.ANALYSIS.TITLE.3': '7天付费用户统计',

  'DATA.REPORT.ANALYSIS.ICON.1':
    '邮件送达后，一周内新注册游戏的用户数量的按日统计',
  'DATA.REPORT.ANALYSIS.ICON.2': '邮件送达后，回流登录游戏的用户数量的按日统计',
  'DATA.REPORT.ANALYSIS.ICON.3':
    '邮件送达后，游戏内发生的付费行为的用户数量的按日统计',

  'DATA.REPORT.CUMULATIVE.USER.NUM.1': '累计注册量',
  'DATA.REPORT.CUMULATIVE.USER.NUM.2': '累计活跃量',
  'DATA.REPORT.CUMULATIVE.USER.NUM.3': '累计付费用户量',

  'DATA.REPORT.CUMULATIVE.RATE.1': '累计注册率（注册用户数/合计送达量）',
  'DATA.REPORT.CUMULATIVE.RATE.2':
    '累计活跃率（累计回流登录游戏用户数/合计送达量）',
  'DATA.REPORT.CUMULATIVE.RATE.3': '累计付费率（累计付费用户数/合计送达量）',

  // 当日发送邮件数据汇总
  'DATA.REPORT.CURRENT.DAY.SUM': '按日统计',

  // v2.1.0 ----------start----------
  // Tab1
  'DATA.REPORT.OVERVIEW.TOTAL.SENT.VOLUME': '发送量',
  'DATA.REPORT.OVERVIEW.TOTAL.SENT.VOLUME.SUBTITLE.1': '发送趋势',
  'DATA.REPORT.OVERVIEW.CARD': '指标',
  'DATA.REPORT.GENERAL.DATA.1': '已发送',
  'DATA.REPORT.GENERAL.DATA.2': '接受',
  'DATA.REPORT.GENERAL.DATA.3': '已送达',
  'DATA.REPORT.GENERAL.DATA.4': '已打开',
  'DATA.REPORT.GENERAL.DATA.5': '注册用户量',
  'DATA.REPORT.GENERAL.DATA.6': '活跃用户量',
  'DATA.REPORT.GENERAL.DATA.7': '付费用户量',
  'DATA.REPORT.GENERAL.DATA.8': '已退订',
  'DATA.REPORT.GENERAL.DATA.9': '已点击',
  'DATA.REPORT.GENERAL.DATA.10': '收件人',
  'DATA.REPORT.GENERAL.TIPS.1': '已发送的邮件的数量',
  'DATA.REPORT.GENERAL.TIPS.2': '',
  'DATA.REPORT.GENERAL.TIPS.3': '送达率 = 送达量/已发送',
  'DATA.REPORT.GENERAL.TIPS.4': '打开率 = 打开量/送达量',
  'DATA.REPORT.GENERAL.TIPS.5': '注册率 = 注册数/送达量',
  'DATA.REPORT.GENERAL.TIPS.6': '活跃率 = 活跃数/送达量',
  'DATA.REPORT.GENERAL.TIPS.7': '付费率 = 付费数/送达量',
  'DATA.REPORT.GENERAL.TIPS.8': '退订率 = 取消订阅量/送达量',
  'DATA.REPORT.GENERAL.TIPS.9': '点击率 = 点击量/送达量',
  'DATA.REPORT.GENERAL.RATE.1': '已过滤',
  'DATA.REPORT.GENERAL.RATE.INFO.1':
    'SmartLink<span class="color-primary">拒绝列表</span>实时过滤中，已过滤 {num} 个订阅者',
  'DATA.REPORT.GENERAL.RATE.INFO.2':
    'SmartLink<span class="color-primary">拒绝列表</span>完成过滤，已过滤 {num} 个订阅者',
  'DATA.REPORT.GENERAL.RATE.INFO.1.L': 'SmartLink',
  'DATA.REPORT.GENERAL.RATE.INFO.1.C': '拒绝列表 ',
  'DATA.REPORT.GENERAL.RATE.INFO.1.R': '实时过滤中，已过滤 {num} 个订阅者',
  'DATA.REPORT.GENERAL.RATE.INFO.2.L': 'SmartLink',
  'DATA.REPORT.GENERAL.RATE.INFO.2.C': '拒绝列表 ',
  'DATA.REPORT.GENERAL.RATE.INFO.2.R': '完成过滤，已过滤 {num} 个订阅者',
  'DATA.REPORT.GENERAL.RATE.2': '',
  'DATA.REPORT.GENERAL.RATE.3': '送达率',
  'DATA.REPORT.GENERAL.RATE.4': '打开率',
  'DATA.REPORT.GENERAL.RATE.5': '注册率',
  'DATA.REPORT.GENERAL.RATE.6': '活跃率',
  'DATA.REPORT.GENERAL.RATE.7': '付费率',
  'DATA.REPORT.GENERAL.RATE.8': '退订率',
  'DATA.REPORT.GENERAL.RATE.9': '点击率',
  'DATA.REPORT.GENERAL.RATE.10': '收件人',
  'DATA.REPORT.GENERAL.DESC.1': '已发送的邮件的数量',
  'DATA.REPORT.GENERAL.DESC.2': '',
  'DATA.REPORT.GENERAL.DESC.3': '已成功送达用户邮箱服务器的消息数量',
  'DATA.REPORT.GENERAL.DESC.4': '被用户打开的邮件数量',
  'DATA.REPORT.GENERAL.DESC.5': '投递后，投递用户注册游戏的数量',
  'DATA.REPORT.GENERAL.DESC.6': '投递后，投递用户登录游戏的数量',
  'DATA.REPORT.GENERAL.DESC.7': '投递后，投递用户游戏内付费的数量',
  'DATA.REPORT.GENERAL.DESC.8': '此活动中取消订阅的数量',
  'DATA.REPORT.GENERAL.DESC.9': '链接被点击的邮件数量',
  'DATA.REPORT.GENERAL.DESC.10': '活动设置的收件人数量',
  'DATA.REPORT.GENERAL.DATA.ADD': '增加游戏中的指标',
  'DATA.REPORT.GENERAL.DATA.CHANGE': '更换',
  // Delivery Analusis
  'DATA.REPORT.DELIVERY.ANALUSIS': '送达分析',
  'DATA.REPORT.GENERAL.DELIVERY.RATE.TITLE': '送达率',
  'DATA.REPORT.GENERAL.OPEN.RATE.TITLE': '打开率',
  'DATA.REPORT.GENERAL.CLICK.RATE.TITLE': '点击率',
  'DATA.REPORT.GENERAL.UNSUB.RATE.TITLE': '取消订阅率',
  'DATA.REPORT.GENERAL.DATA.allRegister': '注册',
  'DATA.REPORT.GENERAL.TIPS.allRegister': '注册率=注册数/送达量',
  'DATA.REPORT.GENERAL.RATE.allRegister': '注册率',
  'DATA.REPORT.GENERAL.DATA.allActive': '活跃',
  'DATA.REPORT.GENERAL.TIPS.allActive': '活跃率=活跃数/送达量',
  'DATA.REPORT.GENERAL.RATE.allActive': '活跃率',
  'DATA.REPORT.GENERAL.DATA.allPayCount': '付费',
  'DATA.REPORT.GENERAL.TIPS.allPayCount': '付费率=付费数/送达量',
  'DATA.REPORT.GENERAL.RATE.allPayCount': '付费率',
  'DATA.REPORT.DELIVERY.CLICKED.ANALYSIS.TITLE': '送达后点击分析',
  'DATA.REPORT.DELIVERIED': '送达日期',
  'DATA.REPORT.DELIVERIED.OPEN.EMAILS.NUM': '累计点击的邮件数量',
  'DATA.REPORT.DELIVERIED.OPEN.EMAILS.RATE': '累计点击的邮件比率',
  'DATA.REPORT.DELIVERIED.DELIVERED.RATE': '送达率',
  'DATA.REPORT.DELIVERIED.OPEN.RATE': '打开率',
  'DATA.REPORT.DELIVERIED.CLICK.RATE': '打开点击率',
  'DATA.REPORT.DELIVERIED.UNSUB.RATE': '退订率',
  'DATA.REPORT.DELIVERIED.DELIVERED': '已送达',
  'DATA.REPORT.DELIVERIED.SENT': '已发送',
  'DATA.REPORT.DELIVERIED.OPEN': '已打开',
  'DATA.REPORT.DELIVERIED.CLICK': '已点击',
  'DATA.REPORT.DELIVERIED.OPENED': '已打开',
  'DATA.REPORT.DELIVERIED.UNSUB': '取消订阅',
  // In-game Behavior Analusis
  'DATA.REPORT.IN.GAME.BEHAVIOR.ANALUSIS': '游戏内行为分析',
  'DATA.REPORT.IN.GAME.BEHAVIOR.REG.COM.RATE': '注册率',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.REGISTERED.USER': '新增注册用户',
  'DATA.REPORT.IN.GAME.BEHAVIOR.ACTIVATION.RATE': '活跃率',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.ACTIVATION.USER': '新增活跃用户',
  'DATA.REPORT.IN.GAME.BEHAVIOR.PAYMENT.RATE': '付费率',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.PAYMENT.USER': '新增付费用户',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.1': '注册率',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.2': '活跃率',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.3': '付费率',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.1': '投递后新增注册用户',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.2': '投递后新增活跃用户',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.3': '投递后新增付费用户',
  // 动态指标
  'DATA.REPORT.DYNAMIC.INDICATORCARD.DOCS':
    '你可以通过APl同步游戏中的数据来添加游戏中的元数据，以跟踪活动的表现情况，可以参考<a href="{ url }" target="_blank">API接口文档</a>。',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.NOTED': '请注意：',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.NOTED.DESC':
    '该指标<b>只</b>计算包含在活动中的玩家。',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.TITLE':
    '根据活动的目的，选择您想查看的指标。',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.1': '注册用户',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.1.DESC':
    '通过 register、userinfo接口，传入reg_time、openid、country、language、email等字段',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.2': '活跃用户',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.2.DESC':
    '通过 login 接口，传入login_time、openid、country、language、level字段',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.3': '付费用户',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.3.DESC':
    '通过 pay 接口, 传入pay_time、openid、billing_id等字段',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.Add': '新增',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.DIS': '无数据，请先访问',
  // 告警线
  'DATA.REPORT.WARNNING.LINE': '警告线',
  'DATA.REPORT.BENCHMARK.LINE': '行业标准线',
  'DATA.REPORT.FILTER.TIME.OPTIONS.7': '最近7天',
  'DATA.REPORT.FILTER.TIME.OPTIONS.14': '最近14天',
  'DATA.REPORT.FILTER.TIME.OPTIONS.30': '最后30天',
  'DATA.REPORT.FILTER.TIME.OPTIONS.90': '最后90天',
  'DATA.REPORT.FILTER.TIME.OPTIONS.CUSTOME': '自定义时间',
  'DATA.REPORT.FILTER.TIME.OPTIONS.GRAININESS.DAY': '按天',
  'DATA.REPORT.FILTER.TIME.OPTIONS.GRAININESS.HOUR': '按小时',
  'DATA.REPORT.FILTER.LANGUAGE.AND.LOCATION': '语言&地区',

  // Delivery status
  'DATA.REPORT.DELIVERY.STATUS.TITLE': '未送达分析',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COMPONENT': '组成',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.NUMBER': '数量（绝对数）',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.SHARE': '占比（百分数）',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.FILTER': '过滤邮件',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.BOUNCE.HARD': '硬反弹',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.BOUNCE.SOFT': '软反弹',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.SUCCESSFUL.DELIVERY': '成功递送',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.TOTAL': '总计',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.TEXT':
    '我们将自动过滤在黑名单中的邮件地址并将硬反弹回的邮件地址放入您的黑名单中（您可以在项目设置中管理您的',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.LINK': '黑名单',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.OVER': ')',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TITLE': '点击表现',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.TITLE': 'Title',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.REMARK': '备注',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.URL': 'URL',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.TOTAL.CLICKS': '总点击',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.UNIQUE.CLICKS': '独立点击',
  'DATA.REPORT.OVERVIEW.DELIVERY.STATUS.PIE.TOLLTIP.NUMBER': '数量',
  'DATA.REPORT.OVERVIEW.DELIVERY.STATUS.PIE.TOLLTIP.SHARE': '占比',
};
